// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://etherscan.io/address/0xEE56e2B3D491590B5b31738cC34d5232F378a8D5
export const SHORT_EXECUTOR = '0xEE56e2B3D491590B5b31738cC34d5232F378a8D5';

// https://etherscan.io/address/0x79426A1c24B2978D90d7A5070a46C65B07bC4299
export const LONG_EXECUTOR = '0x79426A1c24B2978D90d7A5070a46C65B07bC4299';

// https://etherscan.io/address/0xAce1d11d836cb3F51Ef658FD4D353fFb3c301218
export const ARC_TIMELOCK = '0xAce1d11d836cb3F51Ef658FD4D353fFb3c301218';

// https://etherscan.io/address/0x158a6bC04F0828318821baE797f50B0A1299d45b
export const CROSSCHAIN_FORWARDER_POLYGON = '0x158a6bC04F0828318821baE797f50B0A1299d45b';

// https://etherscan.io/address/0x5f5C02875a8e9B5A26fbd09040ABCfDeb2AA6711
export const CROSSCHAIN_FORWARDER_OPTIMISM = '0x5f5C02875a8e9B5A26fbd09040ABCfDeb2AA6711';

// https://etherscan.io/address/0xd1B3E25fD7C8AE7CADDC6F71b461b79CD4ddcFa3
export const CROSSCHAIN_FORWARDER_ARBITRUM = '0xd1B3E25fD7C8AE7CADDC6F71b461b79CD4ddcFa3';

// https://etherscan.io/address/0x2fE52eF191F0BE1D98459BdaD2F1d3160336C08f
export const CROSSCHAIN_FORWARDER_METIS = '0x2fE52eF191F0BE1D98459BdaD2F1d3160336C08f';

// https://etherscan.io/address/0x3215225538da1546FE0DA88ee13019f402078942
export const CROSSCHAIN_FORWARDER_BASE = '0x3215225538da1546FE0DA88ee13019f402078942';

export const CHAIN_ID = 1;
